<template>
  <div
    @click="buttonClicked"
    :style="buttonStyle"
    :class="[
      disabledClass,
      widthClass,
      isInline,
      $store.getters.language.font,
      $store.getters.language.directionClass,
      textSize,
      alignClass,
    ]"
    class="CustomButton lxn-border-round lxn-pos-rel"
  >
    <slot> </slot>
    <div
      v-if="iconLeft"
      class="CustomButton-wrapper-leftIcon lxn-pos-abs"
      :class="directionClassLeft"
    >
      <ButtonIcon
        :size="40"
        :bgColor="iconLeftBgColor"
        :icon="iconLeft"
        :iconColor="iconLeftColor"
        :padding="iconLeftPadding"
      />
    </div>
    <div
      v-if="iconRight"
      class="CustomButton-wrapper-rightIcon lxn-pos-abs"
      :class="directionClassRight"
    >
      <ButtonIcon
        :size="40"
        :bgColor="iconRightBgColor"
        :icon="iconRight"
        :iconColor="iconRightColor"
        :padding="iconRightPadding"
      />
    </div>
    <div
      v-if="buttonState == 'selected'"
      class="CustomButton-wrapper-statusBar lxn-w100 selected lxn-pos-abs"
    ></div>
  </div>
</template>

<script>
import ButtonIcon from "@/components/ButtonIcon.vue";

export default {
  name: "CustomButton",
  props: {
    bgColor: String,
    iconLeft: String,
    iconRight: String,
    iconLeftBgColor: String,
    iconRightBgColor: String,
    iconLeftColor: String,
    iconRightColor: String,
    iconLeftPadding: Number,
    iconRightPadding: Number,
    textColor: String,
    buttonState: String,
    useLanguageDirection: Boolean,
    smallText: Boolean,
    useFontAlign: Boolean,
    disabled: Boolean,
    inlineBlock: Boolean,
    width: [String, Number],
  },
  data: function () {
    return {};
  },
  components: {
    ButtonIcon,
  },
  computed: {
    textSize: function () {
      return this.smallText ? "lxn-text" : "lxn-title";
    },
    alignClass: function () {
      return this.useFontAlign
        ? this.$store.getters.language.textAlignClass
        : "lxn-text-center";
    },
    buttonStyle: function () {
      var buttonStyle = "";
      buttonStyle += "background-color: " + this.bgColor + ";";
      buttonStyle += "color: " + this.textColor + ";";
      if (!isNaN(this.width)) {
        buttonStyle += "width: " + this.width + "%;";
      }
      return buttonStyle;
    },
    disabledClass: function () {
      if (this.disabled) {
        return "disabled";
      } else {
        return "";
      }
    },
    widthClass: function () {
      if (this.width !== undefined) {
        return "lxn-w" + this.width;
      } else if (isNaN(this.width)) {
        return "lxn-w100";
      } else {
        return "lxn-undefined";
      }
    },
    isInline: function () {
      if (this.inlineBlock) {
        return "inline-block";
      } else {
        return "";
      }
    },
    directionClassLeft: function () {
      if (this.useLanguageDirection) {
        if (this.$store.getters.language.texts.isRTL) {
          return "CustomButton-wrapper-leftIcon";
        } else {
          return "CustomButton-wrapper-rightIcon";
        }
      } else {
        return "CustomButton-wrapper-leftIcon";
      }
    },
    directionClassRight: function () {
      if (this.useLanguageDirection) {
        if (this.$store.getters.language.texts.isRTL) {
          return "CustomButton-wrapper-rightIcon";
        } else {
          return "CustomButton-wrapper-leftIcon";
        }
      } else {
        return "CustomButton-wrapper-rightIcon";
      }
    },
  },
  methods: {
    buttonClicked: function () {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.CustomButton {
  height: 50px;
  line-height: 40px;
  padding: 5px;
  cursor: pointer;
}
.CustomButton.mini {
  height: 30px;
  line-height: 30px;
  padding: 5px;
  cursor: pointer;
}
.CustomButton.disabled {
  opacity: 0.5;
}
.CustomButton-wrapper-leftIcon {
  height: 40px;
  width: 40px;
  top: 5px;
  left: 5px;
}
.CustomButton.mini .CustomButton-wrapper-leftIcon {
  height: 30px;
  width: 30px;
  top: 5px;
  left: 5px;
}
.CustomButton-wrapper-rightIcon {
  height: 40px;
  width: 40px;
  top: 5px;
  left: calc(100% - 45px);
}
.CustomButton.mini .CustomButton-wrapper-rightIcon {
  height: 30px;
  width: 30px;
  top: 5px;
  left: calc(100% - 45px);
}
.CustomButton-wrapper-statusBar {
  height: 4px;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
}
.CustomButton-wrapper-statusBar.selected {
  background-color: #1ea5de;
}
</style>
